import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from "../../services/api.service";

@Component({
  selector: 'app-force-change-password',
  templateUrl: './force-change-password.component.html',
  styleUrls: ['./force-change-password.component.scss']
})
export class ForceChangePasswordComponent implements OnInit {

  changePasswordSuccess: boolean;

  changePasswordError: string;

  oldPassword: string;

  newPassword: string;

  newPasswordRetype: string;

  target: string;

  minLengthError: string;

  pwdPattern: string;

  pwdErrorMsg: string;

  pwdMinLength: number;

  mandatoryMsg: string;

  submitted: boolean = false;

  constructor(private router: Router, private api: ApiService) { }

  ngOnInit() {
    this.pwdMinLength = 8;
    this.mandatoryMsg = "";
    this.pwdPattern = "(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*?&])[A-Za-z\d$@$!%*?&].{8,}";
    this.pwdErrorMsg = "Das Passwort muss mindestens 8 Zeichen lang sein und 1 Großbuchstaben, 1 Kleinbuchstaben und 1 Sonderzeichen enthalten";
  }

  changePassword() {
    if (this.newPassword && this.newPasswordRetype) {
      if (this.newPassword != '' && this.newPassword.length < this.pwdMinLength) {
        this.minLengthError = "Das Passwort muss mindestens aus 8 Zeichen bestehen";
        return;
      } else {
        this.minLengthError = "";
      }

      if (this.newPassword != this.newPasswordRetype) {
        this.changePasswordError = "Die Eingaben für das neue Passwort stimmen nicht überein";
        return;
      } else {
        this.changePasswordError = "";
      }

      this.mandatoryMsg = "";
      this.minLengthError = "";
      this.changePasswordError = "";
      this.changePasswordSuccess = false;
      this.api.forcechangePassword(this.newPassword, true).subscribe(d => {
        if (d.Succeeded) {
          this.changePasswordSuccess = true;
          this.newPassword = "";
          this.newPasswordRetype = "";
          this.oldPassword = "";
          this.navigate();
        }
        else {
          this.changePasswordError = d.Error
        }

      }, error => {
        if (error.message) {
          this.changePasswordError = error.message;
        }
        else {
          this.changePasswordError = "Ein Fehler ist aufgetreten";
        }
      });
    }
    else {
      this.mandatoryMsg = "Neues Passwort und Neues Passwort bestätigen sind obligatorisch";
    }
  }

  navigate() {
    if (!this.target) {
      this.target = '/frame/dashboards';
    }
    this.router.navigateByUrl(this.target);
  }
}
